/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Mb } from './Mb';

class BuyerStore extends Mb {
    constructor() {
        super();
        this.baseUrl += '/buyerStore';
    }

    data({ shopStoreId, buyerId, storeId, userName, mobile, currentPage, pageSize } = {}) {
        return super.get('/data', {
            shopStoreId,
            buyerId,
            storeId,
            userName,
            mobile,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, buyerId, storeId, storeBuyerLevelId, buyerRegisterInfo } = {}) {
        return super.post('/save', {
            id,
            buyerId,
            storeId,
            storeBuyerLevelId,
            buyerRegisterInfo,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }
}

export default new BuyerStore();
export { BuyerStore };
